import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FileData } from './upload-files.service';
import { MenuAction, MenuActionType } from '../models/app/menu-action.model';
import { ChatList } from '../models/api/chats.model';
import { PathResponse } from '../models/api/paths.model';

@Injectable({
	providedIn: 'root'
})
export class MenuService {
	mainMenuClosed = signal(false);
	showUserMenu = signal(false);
	chatList = signal<ChatList | undefined | null>(null);
	paths = signal<PathResponse | null>(null);
	currentPathId = signal<number | null>(null);
	currentSection = signal<'training' | 'chat' | undefined>(undefined);
	pendingAction = signal<MenuAction | null>(null);
	pendingMessage = signal<{ question: string; files: FileData[] | undefined } | null>(null);
	showTheme = signal(false);
	firstNavigated = false;
	indexElement?: number;
	chatHistoryId?: number;

	private _action = new Subject<MenuAction>();

	get action$(): Observable<MenuAction> {
		return this._action.asObservable();
	}

	editAction(value: MenuAction) {
		this._action.next(value);
	}
}
